/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IBurgerData } from './burger.data';
import { IBurgerProps } from './burger.props.autogenerated';

export interface IBurgerViewProps extends IBurgerProps<IBurgerData> {}

/**
 *
 * Burger component
 * @extends {React.PureComponent<IBurgerProps<IBurgerData>>}
 */
class Burger extends React.PureComponent<IBurgerProps<IBurgerData>> {
    public render(): JSX.Element | null {

        const viewProps = {
            ...this.props
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }


}

export default Burger;
